module.exports = __webpack_public_path__ + "images/kaitori_bonus_cp_lp/november/mainvisual-present-pc-buyback_400c0939371d3134efbd8ae44e1f5b9a.png";